import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useTax } from '../../hooks/CompanyConfiguration/useTax'
import AddTax from './AddTax'

export default function EditTax() {
  const { tax, getTax } = useTax()
  const params = useParams()
  useEffect(() => {
    getTax({ taxId: params.taxId })
  }, [params.taxId])

  return <> {tax ? <AddTax tax={tax} /> : <Loader />} </>
}
